/* eslint-disable */
import semver from 'semver';
import { MANIFEST } from './constants';

export const getPluginManifestsForType = (state, pluginId) => (state.getIn([MANIFEST, pluginId]));

export const getPluginManifest = (state, pluginId, version) => (state.getIn([MANIFEST, pluginId, version]));

export const getClosestMatchingPluginManifest = (state, pluginId, version) => (
  getPluginManifestsForType(state, pluginId)
    .keySeq()
    .sort(semver.rcompare)
    .find((exactVersion) => (semver.satisfies(exactVersion, version)))
);
